<template>
  <div class="tags-page">
    <div class="container">
      <div class="tags-page__header d-flex">
        <router-link :to="{ name: 'activity-library-homepage' }" class="d-block tags-page__back-to-activities fs-14">Activity Library&nbsp;</router-link>
        <span>/ Activity Configurator</span>
      </div>

      <div class="col-lg-8 p-0">
        <div class="mt-30 container-style mb-30">
          <div class="p-30">
            <div class="row pb-20">
              <div class="text-right">
                <div class="col-md-11 color_grey">
                  <button class="btn btn-default color_blue br-2 edit_button" v-on:click="exportPDF()">
                    Export
                  </button>
                </div>
                <div class="color_grey">
                  <button class="btn btn-default color_blue br-2 edit_button" v-on:click="printScreen()">
                    Print
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div id="activity-info">
                <div class="m-10">
                  <div class="row pb-10">
                    <div class="survey_details_section">
                      <div class="activity_heading_tital">
                        {{ activityData.name }}
                      </div>
                      <div class="activity_export_heading">Activity Export {{ date_function() }}</div>
                    </div>
                    <div class="activity_info_setting_tital p-0 mt-20">
                      Activity Information
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pl-0">
                      <div class="survey_heading">Title:</div>
                      <div class="survey_content mb-17">
                        {{ activityData.name }}
                      </div>
                      <div class="survey_heading" v-if="activityData.abbreviation">
                        Abbreviation:
                      </div>
                      <div class="survey_content mb-17" v-if="activityData.abbreviation">
                        {{ activityData.abbreviation }}
                      </div>
                      <div class="survey_heading">Therapeutic Area:</div>
                      <div class="survey_content mb-17" v-if="activityData.customTherapeuticArea">
                        {{ activityData.customTherapeuticArea }}
                      </div>
                      <div class="survey_content mb-17" v-else>
                        {{ activityData.therapeuticArea }}
                      </div>
                      <div class="survey_heading">Therapeutic Indication:</div>
                      <div class="survey_content mb-17">
                        {{ activityData.therapeuticIndication }}
                      </div>
                      <div class="survey_heading">
                        Approximate Time to Complete:
                      </div>
                      <div class="survey_content">{{ activityData.timeToComplete }} min</div>
                    </div>
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pl-0">
                      <div class="survey_heading">Author:</div>
                      <div class="survey_content mb-17" v-if="activityData.author">
                        {{ activityData.author }}
                      </div>
                      <div class="survey_heading">Copyright:</div>
                      <div class="survey_content mb-17">
                        {{ activityData.copyright }}
                      </div>
                      <div class="survey_heading">Available Languages:</div>
                      <div v-if="activityData.language" class="survey_content mb-17">
                        {{ displayLanguages() }}
                      </div>
                      <div class="survey_heading">Group:</div>
                      <div class="survey_content">
                        {{ activityData.groupName }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="survey_details_section_settings" id="activity-settings">
                  <div class="col-md-11 activity-settings-box pt-0 m-10">
                    <div class="activity_info_setting_tital pt-20 ml-16">
                      Activity settings
                    </div>
                    <div class="col-md-6 fs-14 mt-15 mb-10">
                      <div class="row pb-10">
                        <div class="col-md-10 survey_content p-0">
                          Ability to score responses
                        </div>
                        <div class="col-md-2 survey_heading col-lg-2 p-0" v-if="activityData.canScoreResponses == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10">
                        <div class="col-md-10 survey_content p-0">
                          Allow site users to edit responses
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-if="activityData.allowDataEditChecks == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10">
                        <div class="col-md-10 survey_content p-0">
                          Available for Apple Watch app
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-if="activityData.watchEnabled == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10">
                        <div class="col-md-10 survey_content p-0">
                          Re-population with prior responses
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-if="activityData.prePopulationEnabled == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10">
                        <div class="col-md-10 survey_content p-0">
                          Custom Participant Message
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-if="activityData.customParticipantMessaging == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-else>
                          Disabled
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 fs-14 mt-15 mb-10">
                      <div class="row pb-10">
                        <div class="col-md-10 survey_content p-0">
                          Hide Step Numbers
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-if="activityData.hideNumericLabels == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10">
                        <div class="col-md-10 survey_content p-0">
                          Allow participant to save progress
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-if="activityData.allowSaveProgress == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10">
                        <div class="col-md-10 survey_content p-0">
                          Enable progress indicators
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-if="activityData.enableProgressIndicator == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10">
                        <div class="col-md-10 survey_content p-0">
                          Define devices for completion
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-if="activityData.allowDevicesForCompletion == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-else>
                          Disabled
                        </div>
                      </div>
                      <div class="row pb-10">
                        <div class="col-md-10 survey_content p-0">
                          Allow previous responses to be shown
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-if="activityData.allowPreviousResponses == true">
                          Enabled
                        </div>
                        <div class="survey_heading col-md-2 p-0" v-else>
                          Disabled
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="activity-questions" class="survey_details_section pt-30">
                <reviewQuestions class :questions="questionAnswers" :activityData="activityData"></reviewQuestions>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reviewQuestions from "@/components/activity-library/activity-export-questions";
import toastr from "toastr";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import $ from "jquery";

export default {
  name: "activity-export",
  data() {
    return {
      id: null,
      activityId: null,
      revisionId: null,
      activityData: {},
      sequence: 1,
      questionAnswers: [],
      questionAnswersLength: "",
      selectedQuestion: { value: "Default", label: "- Select -" },
      questions: [],
      therapeuticAreas: [],
      questionPages: []
    };
  },
  components: { reviewQuestions },
  computed: {},
  mounted() {
    this.activityId = this.$route.params.activityId;
    this.revisionId = this.$route.params.revisionId;
    this.getTherapeuticAreas();
  },
  methods: {
    async exportPDF() {
      let pdf = new jsPDF("p", "pt", "a4", true);
      let options = {
        allowTaint: true,
        useCORS: true,
        scale: 2
      };
      const filename = "activity_" + this.activityId + ".pdf";
      let pageCount = 1;
      let img = new Image();
      await html2canvas(document.querySelector("#activity-info"), options).then(async canvas => {
        const imagedata = canvas.toDataURL("image/jpeg");
        const height = pdf.internal.pageSize.getHeight();
        const imgData = await this.imgLoad(canvas, pdf);
        pdf.addImage(imagedata, "JPEG", 10, 10, imgData.imageWidth * imgData.ratio, imgData.imageHeight * imgData.ratio - 40);
        pdf.text(`Page Number - ${pageCount++}`, 10, height - 20);
        pdf.addPage("a4", "p");
      });
      for (var i = 0; i < this.questionPages.length; i++) {
        console.log("Processing question page - ", this.questionPages[i]);
        if (document.querySelector("#" + this.questionPages[i])) {
          await html2canvas(document.querySelector("#" + this.questionPages[i]), options).then(async canvas => {
            img.src = canvas.toDataURL("image/jpeg");
            img.crossOrigin = "Anonymous";
            const height = pdf.internal.pageSize.getHeight();
            const imgData = await this.imgLoad(canvas, pdf);
            pdf.addImage(img, "JPEG", 10, 10, imgData.imageWidth * imgData.ratio, imgData.imageHeight * imgData.ratio - 40);
            if (i != this.questionPages.length - 1) {
              pdf.text(`Page Number - ${pageCount++}`, 10, height - 20);
              pdf.addPage("a4", "p");
            }
          });
        }
      }
      img.addEventListener("load", () => {
        pdf.save(filename);
      });
    },
    imgLoad(canvas, pdf) {
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imageWidth = canvas.width;
      const imageHeight = canvas.height;
      const ratio = imageWidth / imageHeight >= pageWidth / pageHeight ? pageWidth / imageWidth : pageHeight / imageHeight;
      return { imageWidth, imageHeight, ratio };
    },
    printScreen() {
      const container = document.querySelector("#activity-info");
      new Promise(resolve => {
        html2canvas(container, {
          allowTaint: true,
          useCORS: true,
          scale: 2
        }).then(function(canvas) {
          () => false;
          const dataURL = canvas.toDataURL();
          const width = canvas.width;
          const printWindow = window.open("");
          resolve();
          $(printWindow.document.body)
            .html("<img id='Image' src=" + dataURL + " style='" + width + "'></img>")
            .ready(function() {
              printWindow.focus();
              printWindow.print();
            });
        });
      }).then(() => {
        this.isProcessingExport = false;
      });
    },
    getTherapeuticAreas() {
      this.$api
        .getTherapeuticAreas()
        .then(response => {
          this.therapeuticAreas = response.data.result;
          this.getActivityDetails();
        })
        .catch(() => {
          this.$toastr.error("Error in getting Therapeutic Areas");
        });
    },
    getActivityDetails() {
      this.$api.getActivityDetails(this.activityId, this.revisionId).then(
        response => {
          this.activityData = response.data.result;
          this.$store.dispatch("setActivityDetailsAction", response.data.result);
          if (this.activityData.questions && this.activityData.questions.length > 0) {
            this.questionAnswers = this.processQuestion(this.activityData.questions);

            const pages = {};
            let pageIndex = 0;
            const SIZE = 3;
            let currentQuestionCount = 0;
            let pageId;

            pages[pageId] = [];

            let cnt = 0;

            for (let i = 0; i < this.questionAnswers.length; i++) {
              if (((currentQuestionCount == 0 && pages[pageId].length == 0) || currentQuestionCount > SIZE) && this.questionAnswers[i].type != "SurveyCompletion") {
                this.questionAnswers[i].pageId = "page-" + pageIndex;
                this.questionPages.push("page-" + pageIndex);
                pageIndex++;
              }
              if (this.questionAnswers[i].type != "Section") {
                currentQuestionCount++;
              }
              pages[pageId].push(this.questionAnswers[i]);

              if (this.questionAnswers[i].type != "Section") {
                cnt++;
              }
            }
            for (let i = 0; i < this.therapeuticAreas.length; i++) {
              if (this.therapeuticAreas[i].id === this.activityData.therapeuticAreaId) {
                this.activityData.therapeuticArea = this.therapeuticAreas[i].name;
              }
            }
            this.questionAnswersLength = cnt - 1;
            this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
            this.questions = this.activityData.questions;
          }
        },
        error => {
          this.errorMsg = error.body ? error.body.message : "Error while getting activity details";
          toastr.error(this.errorMsg);
        }
      );
    },
    processQuestion(question) {
      question.map(function(value) {
        if (value.type == "SurveyInstruction") {
          if (value.formattedTitle == "") {
            value.formattedTitle = value.title;
          }
          if (value.formattedInformation == "") {
            value.formattedInformation = value.information;
          }
        } else if (value.type == "CustomScale" && value.formattedLabels == undefined) {
          value.formattedLabels = value.labels;
        } else {
          if (value.formattedBody == "") {
            value.formattedBody = value.body;
          }
          if (value.options !== undefined && value.options.formattedBody == "") {
            value.options.formattedBody = value.options.body;
          }
        }
      });
      return question;
    },
    date_function() {
      const formatted_date = moment().format("D MMM YYYY");
      return formatted_date;
    },
    displayLanguages() {
      const language = this.activityData.language.map(language => language.display_name);
      return language.join(", ");
    }
  }
};
</script>

<style scoped lang="scss">
// Style for quick fixes bootstrap after migration (before redesign should be removed)
.tags-page {
  font-family: "RobotoRegular";

  &__back-to-activites {
    color: #4c8ce4;
  }

  .container {
    max-width: 90%;
  }

  &__header {
    margin: 100px auto 0 auto;

    &__add-tag-btn {
      width: 116px;
      height: 35px;
      border-radius: 4px;
      background-color: #4c8ce4;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #ffffff;
    }
  }

  .manage-tags-text {
    height: 24px;
    font-family: "RobotoRegular";
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #000000;
  }

  .manage-tags-description {
    font-family: "RobotoRegular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    color: #000000;
  }

  .add-tag-modal {
    .modal-dialog {
      vertical-align: top !important;
      top: 100px;
    }

    &__container {
      width: 902px;
      height: 219px;
      border-radius: 4px;
      background-color: #ffffff;

      .fw-bold {
        font-weight: bold;
      }

      .color-black {
        color: black;
      }
    }

    &__name-input {
      width: 220px;
      height: 35px;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
    }

    &__desc-input {
      width: 549px;
      height: 35px;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
    }

    &__add-another-tag {
      font-family: "RobotoRegular";
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.67;
      letter-spacing: normal;
      color: #4c8ce4;
      cursor: pointer;
    }

    &__save-tag-btn {
      width: 102px;
      height: 35px;
      border-radius: 4px;
      background-color: #4c8ce4;
      color: white;
    }
  }
}
body {
  color: #333;
}

.h2,
h2 {
  font-size: 30px;
  margin: 20px 0 10px;
}

.h3,
h3 {
  font-size: 24px;
  color: #333;
}

.h5,
h5 {
  font-size: 14px;
  margin: 10px 0;
}

.h6,
h6 {
  font-size: 12px;
  margin: 10px 0;
  color: #333;
}

.btn {
  font-size: 14px;
}

.col-xs-12 {
  width: 100%;
}

.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
  //flex: none;
  display: block;
}

.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.col-xs-10 {
  width: 83.33333333%;
}

.panel-default {
  border-color: #ddd;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.row {
  display: block;

  &:after {
    content: "";
    clear: both;
    display: block;
  }
}

.color_959fa4 {
  color: #959fa4 !important;
}

.scheduler {
  border-bottom: 2px solid #d3dfe4;
  padding-bottom: 30px;
}

@media (min-width: 768px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
    display: block;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-10 {
    width: 83.33333333%;
  }
  .col-sm-4 {
    width: 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-2 {
    flex: none;
  }
}

@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
    flex: none;
  }
  .col-md-2 {
    width: 16.66666667%;
  }
  .col-md-10 {
    width: 83.33333333%;
  }
  .col-md-12 {
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
    display: block;
  }
  .col-lg-2 {
    width: 16.66666667%;
  }
  .col-lg-10 {
    width: 82.33333333%;
  }
  .col-lg-11 {
    width: 91.66666667%;
  }
}

// END of style for quick fixes bootstrap after migration (before redesign should be removed)

h1,
h2,
h3 {
  font-weight: 200;
}
.form-control {
  border-radius: 2px;
}
.pr-0 {
  padding-right: 0;
}

.pl-0 {
  padding-left: 0;
}

.img-style {
  padding-top: 20px;
  height: 300px;
  width: 500px;
  padding-bottom: 20px;
}

.font-style {
  color: #57dd7a;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 30px;
}

.text-style {
  color: #969090;
  text-align: right;
}

.btn-style {
  margin-top: 10px;
  width: 80px;
  height: 29px;
  margin-bottom: 50px;
}

.custom-btn {
  background: #00baf9;
  color: #fff;
  width: 220px;
}

.custom-para {
  padding-bottom: 20px;
  font-size: 20px;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.btn-disabled {
  color: white;
  background-color: #c6c2c2;
  border: #c6c2c2;
}

.text-color {
  color: #888;
}

.read_only_card {
  background-color: #f5f8fa;
  border: 1px solid #d3dfe4;
  border-left: 8px solid #d3dfe4;
  padding: 15px;
  margin-bottom: 16px;
  .instuction_title {
    font-size: 18px;
    font-weight: bold;
  }
}

.survey-name {
  color: #00baf9;
  font-size: 20px;
}

.pad-left50 {
  padding-left: 50px;
}

.button-blue-1 {
  background: #00bae0;
  color: #fff;
}

.button-blue-2 {
  background-color: #0197eb;
  color: #fff;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.mar-bot0 {
  margin-bottom: 0px !important;
}

.first_question_selection {
  img {
    width: 100%;
    max-width: 100px;
  }
  .header {
    font-size: 24px;
    font-weight: 200;
    padding: 14px;
  }
  .label_text {
    font-size: 18px;
    padding-bottom: 10px;
    font-weight: 400;
  }
  select {
    margin: auto;
    width: 100%;
    max-width: 300px;
  }
}
.question_count {
  background-color: #34537d;
  color: #fff;
  width: 25px;
  display: inline-block;
  border-radius: 10px;
  text-align: center;
}
.inner-card {
  border: 1px solid #ddd;
  box-shadow: 1px 0px 1px 1px #ddd;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f6fafc;
}

.select-style {
  background: #f9f9f9;
  border-radius: 2px;
}

.radio-style {
  margin-top: 5px !important;
  font-size: 14px;
  color: #555555;
}
.btn_add {
  border-radius: 25px;
  border: solid 1px #f16559;
  color: #f16559;
  background-color: transparent;
}
.check-style {
  margin-top: 5px !important;
  font-size: 14px;
  color: #555555;
  padding: 0px 20px;
}

.border-left {
  border-left: 1px solid #555555;
}
.container-style {
  border-radius: 2px;
  background-color: #ffffff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}

.input-style {
  width: 45px;
  margin-left: 10px;
  background: #f9f9f9;
  display: initial;
  padding: 5px;
}

.char-style {
  font-size: 14px;
  color: #555555;
}

.card {
  padding: 15px;
  color: #666769 !important;
}

.add_another_btn {
  font-size: 14px;
  background-color: transparent;
  border-color: #f06559;
  color: #f06559;
  margin-bottom: 20px;
}

.preview-btn {
  background-color: #d4f2ff;
  width: 100%;
  // max-width: 150px;
  padding: 10px 0;
}

.icon-style {
  font-size: 47px;
  position: absolute;
  left: 30px;
  /* bottom: 0px; */
  top: -25px;
}

.pl-25 {
  padding-left: 25px;
}

@media (max-width: 575px) {
  .container-padding {
    padding-left: 20px;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
}

@media (min-width: 768px) and (max-width: 991px) {
}

@media (min-width: 992px) and (max-width: 1199px) {
}

@media (min-width: 1200px) {
}

.survey_details_section {
  border-bottom: 2px solid #979797;
  padding-bottom: 20px;
  word-break: break-word !important;
  width: 100%;
  display: flex;
}

.edit_button {
  background-color: #ffffff;
  border: 1px solid #d3dfe4;
  font-size: 12px;
}

.survey_heading {
  color: #b0bac9;
  font-size: 14px;
  font-weight: 600;
}

.survey_content {
  color: #2a2a2a;
  font-size: 14px;
  font-weight: 400;
}

.back_link {
  color: #666669;
}

.reminder_heading {
  color: #666669;
}

.checkbox_position {
  position: relative;
  top: 2px;
}

ul {
  margin: 0;
  padding: 0 0 0 15px;
}
.continue-btn {
  width: 122px;
  height: 36px;
  cursor: pointer;
  background-color: #4c8ce4;
  border-radius: 100px;
  border: solid 2px #4c8ce4;
  outline: none;
}
.continue-btn-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #ffffff;
}
.cancel-btn {
  width: 122px;
  height: 36px;
  background-color: #ffffff !important;
  border-radius: 100px;
  border: solid 2px #ffffff !important;
  cursor: pointer;
  outline: none;
}
.cancel-btn-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #4c8ce4;
}
.activity-settings-box {
  background-color: #f7faff;
  border: #e9eef7 solid 2px;
  border-radius: 5px;
}
.survey_details_section_settings {
  border-bottom: 2px solid #979797;
  padding-bottom: 250px;
}
.activity_export_heading {
  font-size: 18px;
  color: #666669;
  margin-left: 0.6em;
}
.activity_heading_tital {
  font-size: 20px;
  color: #000000;
}
.activity_info_setting_tital {
  font-size: 16px;
  font-weight: 600;
  color: #959fa4;
}
.activityname_setp {
  font-size: 16px;
  color: #000000;
}
</style>
